import React, { useState, useEffect } from 'react';
import { obtenerListadoPedidos } from '../../services/productosApi';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { hoyChile } from '../../services/utils';

const ListadoPedidos = () => {
    const [pedidos, setPedidos] = useState([]);
    const [pedidoSeleccionado, setPedidoSeleccionado] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    
    const [fechas, setFechas] = useState({
        inicio: hoyChile(),
        fin: hoyChile()
    });

    const cargarPedidos = async () => {
        setIsLoading(true);
        try {
            const data = await obtenerListadoPedidos(fechas.inicio, fechas.fin);
            setPedidos(Array.isArray(data) ? data : []);
            if (!data || data.length === 0) toast.info("No se encontraron pedidos en este rango.");
        } catch (e) {
            console.error("Error cargando pedidos:", e);
            toast.error("Error al conectar con el servidor.");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => { cargarPedidos(); }, []);

    const renderItems = (pedido) => {
        try {
            if (!pedido) return null;
            console.log("renderItems - pedido:", pedido.id, "items_json:", pedido.items_json);
            const lista = Array.isArray(pedido.items_json) ? pedido.items_json : (pedido.items_json ? JSON.parse(pedido.items_json) : []);
            console.log("renderItems - lista:", lista);
            if (!lista || lista.length === 0) return <li className="text-muted text-center py-3">Sin productos</li>;
            return lista.map((item, i) => (
                <li key={i} className="d-flex justify-content-between mb-3 border-bottom pb-2">
                    <div style={{ maxWidth: '75%' }}>
                        <span className="font-weight-bold text-dark">{item.cantidad || 1}x</span> {item.nombre || 'Producto'}
                        {(item.variantes || item.variantes_detalles) && (
                            <div className="small text-primary font-weight-bold mt-1" style={{lineHeight: '1.2'}}>
                                <i className="fas fa-level-up-alt fa-rotate-90 mr-1"></i> {item.variantes || item.variantes_detalles}
                            </div>
                        )}
                    </div>
                    <span className="font-weight-bold text-dark">${((item.cantidad || 1) * (item.precio || item.valor || 0)).toLocaleString('es-CL')}</span>
                </li>
            ));
        } catch(e) {
            console.error("Error en renderItems:", e);
            return <li className="text-danger text-center py-3">Error al mostrar productos</li>;
        }
    };

    return (
        <div className="bg-light min-vh-100 py-5 px-3">
            <ToastContainer position="bottom-center" autoClose={2000} hideProgressBar />
            <div className="container" style={{ maxWidth: '1200px' }}>
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-5">
                    <div>
                        <h1 className="h2 font-weight-bold text-dark mb-1">Listado de Pedidos</h1>
                        <p className="text-muted m-0">Historial completo para auditoría y arqueo de caja.</p>
                    </div>
                    <div className="mt-3 mt-md-0">
                        <button className="btn btn-white border rounded-pill shadow-sm px-4 font-weight-bold" onClick={() => window.print()}>
                            <i className="fas fa-print mr-2"></i> Reporte Imprimible
                        </button>
                    </div>
                </div>

                <div className="card border-0 shadow-sm rounded-xl p-4 mb-4">
                    <div className="row align-items-end">
                        <div className="col-md-4 mb-3 mb-md-0">
                            <label className="text-uppercase small font-weight-bold text-muted mb-2 d-block">Desde</label>
                            <input type="date" className="form-control border-light bg-light rounded-pill" value={fechas.inicio} onChange={(e) => setFechas({...fechas, inicio: e.target.value})} />
                        </div>
                        <div className="col-md-4 mb-3 mb-md-0">
                            <label className="text-uppercase small font-weight-bold text-muted mb-2 d-block">Hasta</label>
                            <input type="date" className="form-control border-light bg-light rounded-pill" value={fechas.fin} onChange={(e) => setFechas({...fechas, fin: e.target.value})} />
                        </div>
                        <div className="col-md-4">
                            <button className="btn btn-primary btn-block rounded-pill font-weight-bold shadow-sm py-2" onClick={cargarPedidos} disabled={isLoading}>
                                {isLoading ? <span className="spinner-border spinner-border-sm"></span> : "Consultar Pedidos"}
                            </button>
                        </div>
                    </div>
                </div>

                <div className="card border-0 shadow-sm rounded-xl overflow-hidden mb-5">
                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0">
                            <thead className="bg-light">
                                <tr>
                                    <th className="border-0 px-4 py-3 text-muted small text-uppercase">Orden</th>
                                    <th className="border-0 py-3 text-muted small text-uppercase">Cliente / Tipo</th>
                                    <th className="border-0 py-3 text-muted small text-uppercase">Pago</th>
                                    <th className="border-0 py-3 text-muted small text-uppercase">Total</th>
                                    <th className="border-0 py-3 text-muted small text-uppercase text-center">Estado</th>
                                    <th className="border-0 px-4 py-3 text-right text-muted small text-uppercase">Acción</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <tr><td colSpan="6" className="text-center py-5 text-muted">Buscando...</td></tr>
                                ) : pedidos.map(p => (
                                    <tr key={p.id}>
                                        <td className="px-4 py-3">
                                            <span className="font-weight-bold text-primary">#{p.display_id || p.id}</span>
                                            <small className="d-block text-muted" style={{fontSize: '11px'}}>
                                                <i className="far fa-clock mr-1"></i>
                                                {new Date(p.fecha_creacion).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}
                                            </small>
                                        </td>
                                        <td className="py-3">
                                            <span className="font-weight-bold text-dark d-block">{p.cliente_nombre || 'Caja General'}</span>
                                            <span className="badge badge-light text-muted border-0 p-0" style={{fontSize: '11px'}}>
                                                <i className="fas fa-truck-moving mr-1"></i> {p.entrega_txt}
                                            </span>
                                        </td>
                                        <td className="py-3">
                                            <span className={`badge px-2 py-1 rounded-pill ${p.pagado ? 'badge-soft-success' : 'badge-soft-danger'}`}>
                                                {p.metodo_pago}
                                            </span>
                                        </td>
                                        <td className="py-3 font-weight-bold text-dark">${Number(p.total).toLocaleString('es-CL')}</td>
                                        <td className="py-3 text-center">
                                            <span className="badge badge-light border px-3 py-1 rounded-pill small">{p.estado_txt}</span>
                                        </td>
                                        <td className="px-4 py-3 text-right">
                                            <button className="btn btn-sm btn-outline-primary rounded-pill px-3 font-weight-bold" onClick={() => setPedidoSeleccionado(p)}>Ver Detalle</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {!isLoading && pedidos.length === 0 && (
                            <div className="text-center py-5">
                                <i className="fas fa-search fa-3x text-light mb-3"></i>
                                <p className="text-muted">No hay pedidos registrados en este rango de fechas.</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {pedidoSeleccionado && (
                <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(4px)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content border-0 shadow-lg rounded-xl">
                            <div className="modal-header bg-primary text-white border-0 py-3">
                                <h5 className="modal-title font-weight-bold">Orden #{pedidoSeleccionado.display_id || pedidoSeleccionado.id}</h5>
                                <button className="close text-white outline-none" onClick={() => setPedidoSeleccionado(null)}>&times;</button>
                            </div>
                            <div className="modal-body p-4">
                                <div className="mb-4 bg-light rounded-lg p-3">
                                    <h6 className="text-muted small font-weight-bold text-uppercase mb-2">Datos del Cliente</h6>
                                    <div className="d-flex align-items-start">
                                        <i className="fas fa-user-circle fa-2x text-muted mr-3 mt-1"></i>
                                        <div>
                                            <p className="m-0 font-weight-bold text-dark">{pedidoSeleccionado.cliente_nombre}</p>
                                            <p className="m-0 small text-muted"><i className="fas fa-phone mr-1"></i> {pedidoSeleccionado.cliente_telefono || 'No registrado'}</p>
                                            <p className="m-0 small text-muted"><i className="fas fa-map-marker-alt mr-1"></i> {pedidoSeleccionado.cliente_direccion || 'Consumo en local'}</p>
                                        </div>
                                    </div>
                                </div>
                                <h6 className="text-muted small font-weight-bold text-uppercase mb-3 px-1">Resumen de Compra</h6>
                                <div className="px-1">
                                    <ul className="list-unstyled m-0">{renderItems(pedidoSeleccionado)}</ul>
                                    <div className="d-flex justify-content-between mt-4 p-3 bg-dark text-white rounded-lg shadow-sm">
                                        <span className="h6 m-0 font-weight-bold text-uppercase">Total Pagado</span>
                                        <span className="h5 m-0 font-weight-bold">${Number(pedidoSeleccionado.total).toLocaleString('es-CL')}</span>
                                    </div>
                                    <p className="text-center mt-3 small text-muted">Medio de pago: <strong>{pedidoSeleccionado.metodo_pago}</strong></p>
                                </div>
                            </div>
                            <div className="modal-footer border-0 p-3">
                                <button className="btn btn-light btn-block rounded-pill font-weight-bold py-2" onClick={() => setPedidoSeleccionado(null)}>Cerrar Detalle</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ListadoPedidos;